import { Outlet, ScrollRestoration } from 'react-router';

import { useSessionExpiredPrompt } from '../features/auth/useSessionExpiredPrompt';
import { CookieConsentBanner } from '../features/cookies/CookieConsentBanner';
import { WelcomeSongControl } from '../features/welcomeSong/WelcomeSongControl';
import styles from './RootLayout.module.css';
import { CanonicalLink } from './seo';

/**
 * Raíz de todas las rutas: restaura el scroll al navegar y declara la URL canónica. Los shells viven
 * en cada grupo; aquí solo lo que debe sobrevivir al paso de la landing al mapa (el control de la
 * melodía de bienvenida, el aviso de cookies y el de sesión caducada, que abre el ingreso desde
 * cualquier pantalla). Los avisos flotantes van apilados en un dock para no taparse entre sí.
 */
export function RootLayout() {
  useSessionExpiredPrompt();
  return (
    <>
      <CanonicalLink />
      <Outlet />
      <ScrollRestoration />
      <div className={styles.dock}>
        <CookieConsentBanner />
        <WelcomeSongControl />
      </div>
    </>
  );
}

/** Carga inicial de una ruta diferida (S01 "Preparando el mapa del Parche…"). Liviano: va en el shell. */
export function AppLoading() {
  return (
    <div className="paper" role="status" style={loadingStyle}>
      <svg viewBox="0 0 24 24" width="32" height="32" className="ico" aria-hidden="true" style={{ color: 'var(--terra)' }}>
        <path d="M4 9h13v5a6 6 0 0 1-6 6h-1a6 6 0 0 1-6-6V9Z" />
        <path d="M17 11h1.5a2.5 2.5 0 0 1 0 5H17" />
        <path d="M8 3c0 1.5 1 1.5 1 3" style={{ animation: 'steam 1.8s ease-in-out infinite' }} />
        <path d="M12 3c0 1.5 1 1.5 1 3" style={{ animation: 'steam 1.8s ease-in-out .5s infinite' }} />
      </svg>
      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--cafe2)' }}>Preparando el Parche…</span>
    </div>
  );
}

const loadingStyle = {
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
} as const;
